<template>
    <div class="width-full">
        <v-container fluid grid-list-xl class="container-symptoms-questions general-container">
            <v-layout row wrap class="navigation-header">
                <v-flex xs12>
                    <header-bar-medical-device
                        :shortcut-nav="this.shortcutNav"
                        @setIsKeyboardNav="navSetIsKeyboardNav"
                        :title="text('api.pageTitle.assessmentSymptoms')" ref="headerMedical"></header-bar-medical-device>
                </v-flex>
            </v-layout>

            <div class="scrolling-content-symptoms-priority-list"
                 ref="assessmentPriorityScrollingContentRef">

                <symptoms-questions-content-list-mode ref="symptomsQuestionsContentListModeRef"
                                                      :shortcutNav="this.shortcutNav"
                                                      @emitChangeAnswer="onChangeAnswer"
                                                      @emitQuestionClick="onQuestionClick"
                                                      @emitRelatedSymptomClick="onRelatedSymptomClick"
                                                      @emitRelatedSymptomsPanelClick="onRelatedSymptomsPanelClick"
                                                      @emitNoOtherSymptomsPanelClick="onNoOtherSymptomsPanelClick">
                </symptoms-questions-content-list-mode>

            </div>
        </v-container>

        <v-footer app class="padding-left-xxl padding-right-xxl elevation-bg-color border-top-invisible">
            <v-layout row wrap>
                <v-flex xs12 text-xs-center>

                    <v-btn @click="gotoScoringPage()"
                           id="btnFinishAssessment"
                           class="footer-btn goToScoring"
                           :class="{'is-semi-target': isSemiTarget}"
                           flat
                    >
                        {{text('api.button.finish')}}
                        <finish-icon />
                    </v-btn>

                    <div class="footer-right-btns">
                        <v-btn flat @click="goToPreviousPage" id="btnGoToPrevAssessmentPage" class="footer-btn">
                            <arrow-left-icon/>
                            {{ text('api.button.back') }}
                        </v-btn>

                        <v-btn color="primary"
                               @click="goToNextPage"
                               :loading="getPendingRequest"
                               :disabled="getPendingRequest"
                               id="btnEvaluateAssessment"
                               class="footer-btn footer-btn-next color-on-primary-text"
                               :class="{'is-semi-target grey--text text--darken-1': isSemiTarget}">
                            {{ text('api.button.evaluate')}}
                            <arrow-next-icon :svg-fill-class="'svg-on-primary-color'"/>
                        </v-btn>
                    </div>

                </v-flex>
            </v-layout>
        </v-footer>
        <div class="cookies-display">
            <detect-browser-cookie></detect-browser-cookie>
            <accept-cookie></accept-cookie>
        </div>

        <div v-if="getMustShowVitalParamsForm" class="vital-params-form-overlay overlay overlay--active"></div>
    </div>
</template>

<!-- ################################################################## -->

<script>
import HeaderBar from "../../shared/HeaderBar";
import TopBar from '../../../../common/components/shared/TopBar';

import AssessmentAlerts from "../../../../common/components/shared/AssessmentAlerts";
import PatientInfo from "../../../../common/components/shared/PatientInfo";

import SymptomsQuestionsContent from "../symptoms-panels/SymptomsQuestionsContent";
import SymptomsQuestionsContentListMode from "./SymptomsQuestionsContentListMode";
import AcceptCookie from '../../../../professional/components/cookies/AcceptCookie';
import HeaderBarMedicalDevice from "../../shared/HeaderBarMedicalDevice";
import DetectBrowserCookie from '../../../../common/components/cookies/DetectBrowserCookie';


import {mapActions, mapGetters} from 'vuex';
import FinishIcon from "../../../../common/components/svg/shared/finishIcon";
import ArrowLeftIcon from "../../../../common/components/svg/shared/arrowLeftIcon";
import ArrowNextIcon from "../../../../common/components/svg/shared/arrowNextIcon";

const AP_PANEL = {
        RELATED_SYMPTOMS: "RELATED_SYMPTOMS",
        NO_OTHER_SYMPTOMS: "NO_OTHER_SYMPTOMS",
        QUESTIONS_PANEL: "QUESTIONS_PANEL"
    };

    export default {
        name: 'AssessmentSymptomListView',

        components: {
            ArrowNextIcon,
            ArrowLeftIcon,
            FinishIcon,
            SymptomsQuestionsContent,
            SymptomsQuestionsContentListMode,
            HeaderBar,
            TopBar,
//            PatientProfile,
            AssessmentAlerts,
            PatientInfo,
            AcceptCookie,
            HeaderBarMedicalDevice,
            DetectBrowserCookie
        },

        beforeCreate() {
            if (typeof this.$route.query.referral === "undefined" || this.$route.query.referral !== "testsTreeNode") {
                this.$store.commit('SymptomsQuestionsStore/resetStore');
                this.$store.commit('AssessmentAlertsStore/resetStore');
            }
        },

        created () {

            // If the url has param ?referral=testsTreeNode, that means that we are coming from tests tree,
            // so data for this page should be already loaded and must be kept and used.
            // Otherwise, (re)load data now.
            if (typeof this.$route.query.referral !== "undefined" && this.$route.query.referral === "testsTreeNode") {
                this.$router.replace({'referral': null});
            } else {
                let requestLoadSymptomsQuestionsData = this.$store.dispatch('SymptomsQuestionsStore/loadSymptomsQuestionsDataForListMode');
                requestLoadSymptomsQuestionsData.catch((error) => {
                    // If no Main Symptom has been choosed yet (server sends {returnCode:205}), redirect to Assessment Start page.
                    if (typeof error.serverResponse !== "undefined"
                        && typeof error.serverResponse.data !== "undefined"
                        && typeof error.serverResponse.data.returnCode !== "undefined"
                        && error.serverResponse.data.returnCode === 205) {
                        this.$router.push('/assessment-start-list');
                    }
                });
            }

            window.addEventListener('keydown', this.handleKeyDowns);
            window.addEventListener('keyup', this.handleKeyUps);
            window.addEventListener('click', this.handleClicks);
        },

        destroyed() {

            window.removeEventListener('keydown', this.handleKeyDowns);
            window.removeEventListener('keyup', this.handleKeyUps);
            window.removeEventListener('click', this.handleClicks);
        },

        data() {
            return {
                tempPatientComment: "",
                showComment: false,

                shortcutNav: {

                    isKeyboardNav: false,
                    isPanelHighlight: false,

                    crtPanel: AP_PANEL.RELATED_SYMPTOMS,
                    crtQuestion: null,
                    crtAnswer: null,

                    crtRelatedSymptom: null,
                    crtRelatedSymptomYes: true

                },

                isKeyDown: {}

            };
        },

        computed: {
            ...mapGetters({
                isAdmin: 'UserStore/getIsAdmin',
                isFooterNextBtnEnabled: 'SymptomsQuestionsStore/getIsFooterNextBtnEnabled',
                patientProfileData: 'AssessmentStartStore/getPatientProfileData',
                getIsQuestionListModeEnabled: 'SymptomsQuestionsStore/getIsQuestionListModeEnabled',
                getPendingRequest: 'SymptomsQuestionsStore/getPendingRequest',

                relatedSymptomList: 'SymptomsQuestionsStore/getRelatedSymptomList',
                symptomStates: 'SymptomsQuestionsStore/getRelatedSymptomStates',
                noOtherSymptomsCheck: 'SymptomsQuestionsStore/getNoOtherSymptomsCheck',
                questionListPriority: 'SymptomsQuestionsStore/getSelectedRelatedSymptomListPriority',
                mustShowScoringPopup: 'AssessmentAlertsStore/getMustShowScoringPopup',
                mustShowUrgentPopup: 'AssessmentAlertsStore/getMustShowUrgentPopup',
                mustShowVitalParametersForm: 'VitalParametersStore/getMustShowVitalParamsForm',
                getSemiTarget: 'AssessmentAlertsStore/getSemiTarget',
                medicalStatuses: 'AssessmentAlertsStore/getMedicalStatuses',
                medicalStatus: 'AssessmentAlertsStore/getMedicalStatus',
                getMustShowAssessmentList: 'SymptomsQuestionsStore/getMustShowAssessmentList',
                getMustShowEvaluationPage: 'TranslationStore/getMustShowEvaluationPage',
                getShowUserComment: 'TranslationStore/getShowUserComment',
                getShowUserCommentShortcut: 'TranslationStore/getShowUserCommentShortcut',
                mustShowInfoPopup: 'MedicalDeviceInfoStore/getMustShowMedicalDeviceInfoPopup',
                getMustShowVitalParamsForm: 'VitalParametersStore/getMustShowVitalParamsForm',

            }),

            isQuestionListModeEnabled: {
                get () {
                    return this.$store.getters['SymptomsQuestionsStore/getIsQuestionListModeEnabled'];
                },
                set (isListModeNewValue) {
                    let requestLoadData;

                    if (isListModeNewValue === true) {
                        requestLoadData = this.$store.dispatch('SymptomsQuestionsStore/loadSymptomsQuestionsDataForListMode');
                    }
                    else {
                        requestLoadData = this.$store.dispatch('SymptomsQuestionsStore/loadSymptomsQuestionsData');
                    }

                    requestLoadData.then(() => {
                        this.$store.commit('SymptomsQuestionsStore/setIsQuestionListModeEnabled', isListModeNewValue);
                    });
                }
            },
            mustShowCodes: {
                get () {
                    return this.$store.getters['UserStore/getDebugMustShowIds'];
                },
                set (newVal) {
                    this.$store.commit('UserStore/setDebugMustShowIds', newVal);
                }
            },

            isSemiTarget () {
                // I created a computed method to be useful if we will need to add a more complex condition
                // in order to visually mark the semiTarget attribute in the page (ex. buttons colors).
                return ((this.getSemiTarget === true) ? true : false);
            }
        },

        watch: {

            mustShowScoringPopup(newValue, oldValue) {
                this.navHandleDropdownsAfterClosingPopups(newValue);
            },

            mustShowUrgentPopup(newValue, oldValue) {
                this.navHandleDropdownsAfterClosingPopups(newValue);
            },

            getShowUserComment(newValue) {
                this.navHandleDropdownsAfterClosingPopups(newValue);
            }

        },

        methods: {

            ...mapActions({
                showScoringPopup: 'AssessmentAlertsStore/showScoringPopup'
            }),

            setTemporaryPatientCommentValue() {
                this.tempPatientComment = this.patientProfileData.comment;

                // Place cursor at the end of the patient comment text
                let commentId = document.getElementById("comment");
                if (commentId != null) {

                    let commentLength = commentId.value.length;
                    commentId.selectionStart = commentLength;
                    commentId.selectionEnd = commentLength;
                }
            },

            isPatientCommentChanged: function () {
                return this.tempPatientComment !== this.patientProfileData.comment;
            },

            savePatientComment: function() {
                if (this.$refs.headerMedical.isPatientCommentChanged() && this.getShowUserCommentShortcut) {
                    this.$store.dispatch("AssessmentStartStore/submitPatientProfileComment", {
                        fieldName: "COMMENT",
                        fieldValue: this.patientProfileData.comment
                    });
                }
                this.showComment = false;
                this.$store.commit('TranslationStore/setShowUserComment', this.showComment);
                this.$store.commit('TranslationStore/setShowUserCommentShortcut', this.showComment);
            },


            goToPreviousPage() {
                this.$router.push('/main-symptom');
            },

            goToNextPage() {
                    this.$store.commit('SymptomsQuestionsStore/setPendingRequest', true);
                    let promiseEvaluateAssessment = this.$store.dispatch('EvaluationStore/evaluateAssessment', {
                        shortcutUsed: false
                    });

                    promiseEvaluateAssessment.then((promise) => {

                        const promiseData = promise.data.data.EVALUATION_STATUS.hasScoringData;

                        if(promiseData && this.getMustShowEvaluationPage) {
                            this.$router.push('/evaluation', () => {
                                this.$store.commit('SymptomsQuestionsStore/setPendingRequest', false);
                            })
                        } else {
                            this.$router.push('/scoring', () => {
                                this.$store.commit('SymptomsQuestionsStore/setPendingRequest', false);
                            })
                        }

                    });
                    promiseEvaluateAssessment.catch(() => {
                        this.$store.commit('SymptomsQuestionsStore/setPendingRequest', false);
                        // @TODO This alert with static text is just a quick solution until we decide what to display to the user when the request wasn't successfully done. Need to replace alert() with something else and the text must use translation mechanism.
                        alert("Couldn't evaluate assessment. Please try again.");
                    });
            },
            gotoScoringPage(){
                let promiseEvaluateAssessment = this.$store.dispatch('EvaluationStore/evaluateAssessment', {
                    shortcutUsed: true
                });
                promiseEvaluateAssessment.then(() => {
                    this.$store.commit('ScoringStore/clearTestTreeData');
                    this.$router.push('/scoring');
                });
                promiseEvaluateAssessment.catch(() => {
                    // @TODO This alert with static text is just a quick solution until we decide what to display to the user when the request wasn't successfully done. Need to replace alert() with something else and the text must use translation mechanism.
                    alert("Couldn't evaluate assessment. Please try again.");
                });
            },


            /*******************************
             ***   KEYBOARD NAVIGATION   ***
             ***      BEGIN CODE         ***
             *******************************/

            // Handle Key/Mouse

            handleKeyDowns(event) {

                if (this.mustShowUrgentPopup === true || this.mustShowVitalParametersForm === true) {
                    return;
                }

                switch (event.keyCode) {

                    // Tab
                    case 9:
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        return false;

                    // Escape
                    case 27:
                        // Escape
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {
                            // If patient comment is shown, close it
                            if (this.getShowUserComment === true) {
                                this.savePatientComment();
                            }
                        }
                        break;

                    // M
                    case 77:
                        // ALT + M
                        if (event.shiftKey === false && event.altKey === true && event.ctrlKey === false) {
                            event.preventDefault();
                            event.stopPropagation();
                            event.stopImmediatePropagation();

                            // If the keyboard combination has been pressed while scoring popup is shown, then close scoring popup
                            if (this.mustShowScoringPopup === true) {
                                this.$store.commit('AssessmentAlertsStore/setMustShowScoringPopup', false);
                            }

                            if (this.mustShowInfoPopup === true) {
                                this.$store.commit('MedicalDeviceInfoStore/setMustShowMedicalDeviceInfoPopup', false);
                            }

                            this.showComment = true;
                            this.$store.commit('TranslationStore/setShowUserComment', this.showComment);
                            this.$store.commit('TranslationStore/setShowUserCommentShortcut', this.showComment);
                        }
                        break;

                    // P
                    case 80:
                        // ALT + P
                        if (event.shiftKey === false && event.altKey === true && event.ctrlKey === false) {

                            if (this.medicalStatus === this.medicalStatuses.INFORMATION
                                || this.medicalStatus === this.medicalStatuses.URGENT) {

                                // for IE 11  - disable default behaviour
                                event.preventDefault();

                                if (this.mustShowInfoPopup === true) {
                                    this.$store.commit('MedicalDeviceInfoStore/setMustShowMedicalDeviceInfoPopup', false);
                                }

                                if (this.getShowUserComment === true) {
                                    this.savePatientComment();
                                }

                                this.showScoringPopup();
                            }
                        }
                        break;

                    case 86:
                        // ALT + V
                        if (event.shiftKey === false && event.altKey === true && event.ctrlKey === false) {
                            // Prevent the default behavior
                            event.preventDefault();


                            // If the scoring popup is shown, then close it
                            if (this.mustShowScoringPopup === true) {
                                this.$store.commit('AssessmentAlertsStore/setMustShowScoringPopup', false);
                            }

                            // If the info popup is shown, then close it
                            if (this.mustShowInfoPopup === true) {
                                this.$store.commit('MedicalDeviceInfoStore/setMustShowMedicalDeviceInfoPopup', false);
                            }


                            // If we have a field in edit, then exit editing
                            if (this.shortcutNav.isFieldInEdit === true) {
                                this.shortcutNav.isFieldInEdit = false;
                            }

                            // Open the dropdown for vital parameters
                            this.$store.commit('VitalParametersStore/setMustShowVitalParamsForm', true);

                            // Enable keyboard navigation
                            this.shortcutNav.isKeyboardNav = true;
                        }

                        break;

                }

                if (this.mustShowScoringPopup === true || this.getShowUserComment === true || this.mustShowInfoPopup === true) {
                    return;
                }

                switch (event.keyCode) {

                    // Backspace
                    case 8:
                    // ALT
                    case 18:
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        return false;

                    // PageUp
                    case 33:
                        // PageUp
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {
                            event.preventDefault();
                            this.$refs["assessmentPriorityScrollingContentRef"].scrollTop -= 50;
                        }
                        break;

                    // PageDown
                    case 34:
                        // PageDown
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {
                            event.preventDefault();
                            this.$refs["assessmentPriorityScrollingContentRef"].scrollTop += 50;
                        }
                        break;

                    // Home
                    case 36:
                        // Shift + Home
                        if (event.ctrlKey === false && event.altKey === false && event.shiftKey === true) {
                            this.navGotoFirstPage();
                        }
                        break;

                    // ArrowLeft
                    case 37:
                    // ArrowUp
                    case 38:
                    // ArrowRight
                    case 39:
                    // ArrowDown
                    case 40:
                        event.preventDefault();
                        break;

                }

                //Prevent repeated calls for certain keys
                if (this.isKeyDown[event.keyCode] === true) {
                    return;
                }
                this.isKeyDown[event.keyCode] = true;

                switch (event.keyCode) {

                    // Enter
                    case 13:

                        if (this.shortcutNav.isKeyboardNav === false) {
                            return;
                        }

                        event.preventDefault();
                        switch (this.shortcutNav.crtPanel) {

                            case AP_PANEL.RELATED_SYMPTOMS:
                                // Do nothing. Checkboxes are acted by Enter having the focus on them
                                break;

                            case AP_PANEL.NO_OTHER_SYMPTOMS:
                                // Do nothing. Checkbox is acted by Enter having the focus on it
                                break;

                            case AP_PANEL.QUESTIONS_PANEL:

                                let questionPanelPage = this.$refs["symptomsQuestionsContentListModeRef"].$refs["symptomsPriorityListRef"];
                                if (questionPanelPage != null
                                    && questionPanelPage.handleChangeAnswerFromPriorityPage != null) {

                                    let questionIdx = this.questionListPriority.findIndex((currentQuestion) => {
                                        return currentQuestion.code === this.shortcutNav.crtQuestion;
                                    });

                                    if (questionIdx >= 0) {

                                        let question = this.questionListPriority[questionIdx];

                                        // is answered by Vital Parameter => open Vital Parameters Form
                                        if (question.answeredByVitalParam != null) {
                                            this.$store.commit('VitalParametersStore/setMustShowVitalParamsForm', true);
                                            this.$store.commit('VitalParametersStore/setFocusVitalParameter', question.answeredByVitalParam);

                                            // lose focus on current question => at Shift focus on the first Question
                                            this.shortcutNav.crtQuestion = null;
                                            this.shortcutNav.crtAnswer = null;
                                        }
                                        else {
                                            // is not answered by Vital Parameter => provide answer on Enter
                                            if (question.providedAnswer === this.shortcutNav.crtAnswer) {
                                                questionPanelPage.handleChangeAnswerFromPriorityPage(this.shortcutNav.crtQuestion, this.shortcutNav.crtAnswer, false, question.answers);
                                            }
                                            else {
                                                questionPanelPage.handleChangeAnswerFromPriorityPage(this.shortcutNav.crtQuestion, this.shortcutNav.crtAnswer, true, question.answers);
                                            }
                                        }
                                    }
                                }

                                break;
                        }
                        break;

                    // Shift
                    case 16:
                        // SHIFT
                        event.preventDefault();
                        if (this.getShowUserComment === false) {
                            this.navEnablePanelHighlight();
                        }
                        break;

                    // PageUp
                    case 33:
                        // SHIFT + PageUp
                        if (event.shiftKey === true && event.altKey === false && event.ctrlKey === false) {

                            this.goToPreviousPage()
                        }

                        break;

                    // PageDown
                    case 34:
                        // SHIFT + PageDown
                        if (event.shiftKey === true && event.altKey === false && event.ctrlKey === false) {
                            this.goToNextPage();
                        }

                        break;

                    // End
                    case 35:
                        // SHIFT + End
                        if (event.shiftKey === true && event.altKey === false && event.ctrlKey === false) {

                            this.gotoScoringPage();
                        }
                        break;

                    // ArrowLeft
                    case 37:

                        if (this.getShowUserComment === true) {
                            return;
                        }

                        this.navSetIsKeyboardNav(true);

                        // LEFT
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {

                            switch (this.shortcutNav.crtPanel) {
                                case AP_PANEL.RELATED_SYMPTOMS:
                                    if (this.relatedSymptomList.length > 0) {

                                        if (this.shortcutNav.crtRelatedSymptom === null) {
                                            this.navSelectRelatedSymptom(0);
                                        }
                                        else {
                                            this.shortcutNav.crtRelatedSymptomYes = !this.shortcutNav.crtRelatedSymptomYes;
                                            this.navFindCheckboxRelatedSymptom(true);
                                        }
                                    }
                                    break;

                                case AP_PANEL.QUESTIONS_PANEL:
                                    this.navAnswersRightLeft(false);
                                    break;
                            }
                        }
                        // CTRL + LEFT
                        else if (event.shiftKey === false && event.altKey === false && event.ctrlKey === true) {

                            switch (this.shortcutNav.crtPanel) {
                                case AP_PANEL.RELATED_SYMPTOMS:
                                    if (this.shortcutNav.crtRelatedSymptom === null) {
                                        this.navSelectRelatedSymptom(0);
                                    }
                                    else {
                                        this.shortcutNav.crtRelatedSymptomYes = true;
                                        this.navFindCheckboxRelatedSymptom(true);
                                    }
                                    break;

                                case AP_PANEL.QUESTIONS_PANEL:
                                    this.navAnswersLeftEdge();
                                    break;
                            }
                        }
                        // SHIFT + LEFT
                        else if (event.shiftKey === true && event.altKey === false && event.ctrlKey === false) {

                            // Small and Up (> 600px)
                            // One column with RELATED_SYMPTOMS and possible NO_OTHER_SYMPTOMS
                            // One columns with QUESTIONS_PANEL
                            if (this.$vuetify.breakpoint.smAndUp) {

                                switch (this.shortcutNav.crtPanel) {
                                    case AP_PANEL.RELATED_SYMPTOMS:
                                    case AP_PANEL.NO_OTHER_SYMPTOMS:
                                        this.navQuestionsTop();
                                        break;

                                    case AP_PANEL.QUESTIONS_PANEL:
                                        this.navSetShortcutNavCrtPanel(AP_PANEL.RELATED_SYMPTOMS, true);
                                        break;
                                }
                            }
                            // Extra small (<600px)
                            // One column with RELATED_SYMPTOMS, possible NO_OTHER_SYMPTOMS and QUESTIONS_PANEL
                            else if (this.$vuetify.breakpoint.xsOnly) {

                                switch (this.shortcutNav.crtPanel) {
                                    case AP_PANEL.RELATED_SYMPTOMS:
                                    case AP_PANEL.NO_OTHER_SYMPTOMS:
                                    case AP_PANEL.QUESTIONS_PANEL:
                                        break;
                                }
                            }
                        }
                        // SHIFT + CTRL + LEFT
                        else if (event.shiftKey === true && event.altKey === false && event.ctrlKey === true) {

                            // Small and Up (> 600px)
                            // One column with RELATED_SYMPTOMS and possible NO_OTHER_SYMPTOMS
                            // One columns with QUESTIONS_PANEL
                            if (this.$vuetify.breakpoint.smAndUp) {

                                switch (this.shortcutNav.crtPanel) {
                                    case AP_PANEL.RELATED_SYMPTOMS:
                                    case AP_PANEL.NO_OTHER_SYMPTOMS:
                                        break;

                                    case AP_PANEL.QUESTIONS_PANEL:
                                        this.navSetShortcutNavCrtPanel(AP_PANEL.RELATED_SYMPTOMS, true);
                                        break;
                                }
                            }
                            // Extra small (<600px)
                            // One column with RELATED_SYMPTOMS, possible NO_OTHER_SYMPTOMS and QUESTIONS_PANEL
                            else if (this.$vuetify.breakpoint.xsOnly) {

                                switch (this.shortcutNav.crtPanel) {
                                    case AP_PANEL.RELATED_SYMPTOMS:
                                    case AP_PANEL.NO_OTHER_SYMPTOMS:
                                    case AP_PANEL.QUESTIONS_PANEL:
                                        break;
                                }
                            }
                        }
                        break;

                    // ArrowUp
                    case 38:

                        if (this.getShowUserComment === true) {
                            return;
                        }

                        this.navSetIsKeyboardNav(true);

                        // UP
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {

                            switch (this.shortcutNav.crtPanel) {

                                case AP_PANEL.RELATED_SYMPTOMS:

                                    if (this.relatedSymptomList.length > 0) {

                                        if (this.shortcutNav.crtRelatedSymptom === null) {
                                            this.navSelectRelatedSymptom(0);
                                        }
                                        else {

                                            let currentRelatedSymptomIdx = this.navGetCurrentRelatedSymptomIdx();
                                            if (currentRelatedSymptomIdx < 0) {
                                                this.navSelectRelatedSymptom(0);
                                            }
                                            else if (currentRelatedSymptomIdx === 0) {
                                                this.navSelectRelatedSymptom(this.relatedSymptomList.length - 1);
                                            }
                                            else {
                                                this.navSelectRelatedSymptom(currentRelatedSymptomIdx - 1);
                                            }

                                        }
                                    }
                                    break;

                                case AP_PANEL.QUESTIONS_PANEL:
                                    this.navAnswersUp();
                                    break;

                            }
                        }
                        // CTRL + UP
                        else if (event.shiftKey === false && event.altKey === false && event.ctrlKey === true) {

                            switch (this.shortcutNav.crtPanel) {
                                case AP_PANEL.RELATED_SYMPTOMS:
                                    if (this.relatedSymptomList.length > 0) {
                                        this.navSelectRelatedSymptom(0);
                                    }
                                    break;

                                case AP_PANEL.QUESTIONS_PANEL:
                                    this.navAnswersTop();
                                    break;
                            }
                        }
                        // SHIFT + UP
                        else if (event.shiftKey === true && event.altKey === false && event.ctrlKey === false) {

                            // Small and Up (> 600px)
                            // One column with RELATED_SYMPTOMS and possible NO_OTHER_SYMPTOMS
                            // One columns with QUESTIONS_PANEL
                            if (this.$vuetify.breakpoint.smAndUp) {

                                switch (this.shortcutNav.crtPanel) {
                                    case AP_PANEL.RELATED_SYMPTOMS:
                                        if (this.noOtherSymptomsCheck === true) {
                                            this.navSetShortcutNavCrtPanel(AP_PANEL.NO_OTHER_SYMPTOMS, true);
                                        }
                                        break;

                                    case AP_PANEL.NO_OTHER_SYMPTOMS:
                                        this.navSetShortcutNavCrtPanel(AP_PANEL.RELATED_SYMPTOMS, true);
                                        break;

                                    case AP_PANEL.QUESTIONS_PANEL:
                                        this.navQuestionsUp();
                                        break;
                                }
                            }
                            // Extra small (<600px)
                            // One column with RELATED_SYMPTOMS, possible NO_OTHER_SYMPTOMS and QUESTIONS_PANEL
                            else if (this.$vuetify.breakpoint.xsOnly) {

                                switch (this.shortcutNav.crtPanel) {
                                    case AP_PANEL.RELATED_SYMPTOMS:
                                        this.navQuestionsBottom();
                                        break;

                                    case AP_PANEL.NO_OTHER_SYMPTOMS:
                                        this.navSetShortcutNavCrtPanel(AP_PANEL.RELATED_SYMPTOMS, true);
                                        break;

                                    case AP_PANEL.QUESTIONS_PANEL:

                                        let crtQuestionIdx = this.navGetCrtQuestionIdx();
                                        if (crtQuestionIdx < 0) {
                                            this.navSelectQuestion(0);
                                            return;
                                        }

                                        if (crtQuestionIdx === 0) {
                                            if (this.noOtherSymptomsCheck === true) {
                                                this.navSetShortcutNavCrtPanel(AP_PANEL.NO_OTHER_SYMPTOMS, true);
                                            }
                                            else {
                                                this.navSetShortcutNavCrtPanel(AP_PANEL.RELATED_SYMPTOMS, true);
                                            }
                                        }
                                        else {
                                            this.navSelectQuestion(crtQuestionIdx - 1);
                                        }
                                        break;
                                }
                            }
                        }
                        // SHIFT + CTRL + UP
                        else if (event.shiftKey === true && event.altKey === false && event.ctrlKey === true) {

                            // Small and Up (> 600px)
                            // One column with RELATED_SYMPTOMS and possible NO_OTHER_SYMPTOMS
                            // One columns with QUESTIONS_PANEL
                            if (this.$vuetify.breakpoint.smAndUp) {

                                switch (this.shortcutNav.crtPanel) {
                                    case AP_PANEL.RELATED_SYMPTOMS:
                                        break;

                                    case AP_PANEL.NO_OTHER_SYMPTOMS:
                                        this.navSetShortcutNavCrtPanel(AP_PANEL.RELATED_SYMPTOMS, true);
                                        break;

                                    case AP_PANEL.QUESTIONS_PANEL:
                                        this.navQuestionsTop();
                                        break;

                                }
                            }
                            // Extra small (<600px)
                            // One column with RELATED_SYMPTOMS, possible NO_OTHER_SYMPTOMS and QUESTIONS_PANEL
                            else if (this.$vuetify.breakpoint.xsOnly) {
                                this.navSetShortcutNavCrtPanel(AP_PANEL.RELATED_SYMPTOMS, true);
                            }
                        }
                        break;

                    // ArrowRight
                    case 39:

                        if (this.getShowUserComment === true) {
                            return;
                        }

                        this.navSetIsKeyboardNav(true);

                        // RIGHT
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {

                            switch (this.shortcutNav.crtPanel) {
                                case AP_PANEL.RELATED_SYMPTOMS:
                                    if (this.relatedSymptomList.length > 0) {

                                        if (this.shortcutNav.crtRelatedSymptom === null) {
                                            this.navSelectRelatedSymptom(0);
                                        }
                                        else {
                                            this.shortcutNav.crtRelatedSymptomYes = !this.shortcutNav.crtRelatedSymptomYes;
                                            this.navFindCheckboxRelatedSymptom(true);
                                        }
                                    }
                                    break;

                                case AP_PANEL.QUESTIONS_PANEL:
                                    this.navAnswersRightLeft(true);
                                    break;
                            }
                        }
                        // CTRL + RIGHT
                        else if (event.shiftKey === false && event.altKey === false && event.ctrlKey === true) {

                            switch (this.shortcutNav.crtPanel) {
                                case AP_PANEL.RELATED_SYMPTOMS:
                                    if (this.shortcutNav.crtRelatedSymptom === null) {
                                        this.navSelectRelatedSymptom(0);
                                    }
                                    else {
                                        this.shortcutNav.crtRelatedSymptomYes = false;
                                        this.navFindCheckboxRelatedSymptom(true);
                                    }
                                    break;

                                case AP_PANEL.QUESTIONS_PANEL:
                                    this.navAnswersRightEdge();
                                    break;
                            }
                        }
                        // SHIFT + RIGHT
                        else if (event.shiftKey === true && event.altKey === false && event.ctrlKey === false) {

                            // Small and Up (> 600px)
                            // One column with RELATED_SYMPTOMS and possible NO_OTHER_SYMPTOMS
                            // One columns with QUESTIONS_PANEL
                            if (this.$vuetify.breakpoint.smAndUp) {

                                switch (this.shortcutNav.crtPanel) {
                                    case AP_PANEL.RELATED_SYMPTOMS:
                                    case AP_PANEL.NO_OTHER_SYMPTOMS:
                                        this.navQuestionsTop();
                                        break;

                                    case AP_PANEL.QUESTIONS_PANEL:
                                        this.navSetShortcutNavCrtPanel(AP_PANEL.RELATED_SYMPTOMS, true);
                                        break;
                                }
                            }
                            // Extra small (<600px)
                            // One column with RELATED_SYMPTOMS, possible NO_OTHER_SYMPTOMS and QUESTIONS_PANEL
                            else if (this.$vuetify.breakpoint.xsOnly) {

                                switch (this.shortcutNav.crtPanel) {
                                    case AP_PANEL.RELATED_SYMPTOMS:
                                    case AP_PANEL.NO_OTHER_SYMPTOMS:
                                    case AP_PANEL.QUESTIONS_PANEL:
                                        break;
                                }
                            }
                        }
                        // SHIFT + CTRL + RIGHT
                        else if (event.shiftKey === true && event.altKey === false && event.ctrlKey === true) {

                            // Small and Up (> 600px)
                            // One column with RELATED_SYMPTOMS and possible NO_OTHER_SYMPTOMS
                            // One columns with QUESTIONS_PANEL
                            if (this.$vuetify.breakpoint.smAndUp) {

                                switch (this.shortcutNav.crtPanel) {
                                    case AP_PANEL.RELATED_SYMPTOMS:
                                    case AP_PANEL.NO_OTHER_SYMPTOMS:
                                        this.navQuestionsTop();
                                        break;

                                    case AP_PANEL.QUESTIONS_PANEL:
                                        break;
                                }
                            }
                            // Extra small (<600px)
                            // One column with RELATED_SYMPTOMS, possible NO_OTHER_SYMPTOMS and QUESTIONS_PANEL
                            else if (this.$vuetify.breakpoint.xsOnly) {

                                switch (this.shortcutNav.crtPanel) {
                                    case AP_PANEL.RELATED_SYMPTOMS:
                                    case AP_PANEL.NO_OTHER_SYMPTOMS:
                                    case AP_PANEL.QUESTIONS_PANEL:
                                        break;
                                }
                            }
                        }
                        break;

                    // ArrowDown
                    case 40:

                        if (this.getShowUserComment === true) {
                            return;
                        }

                        this.navSetIsKeyboardNav(true);

                        // DOWN
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {

                            switch (this.shortcutNav.crtPanel) {
                                case AP_PANEL.RELATED_SYMPTOMS:

                                    if (this.relatedSymptomList.length > 0) {

                                        if (this.shortcutNav.crtRelatedSymptom === null) {
                                            this.navSelectRelatedSymptom(0);
                                        }
                                        else {

                                            let currentRelatedSymptomIdx = this.navGetCurrentRelatedSymptomIdx();
                                            if (currentRelatedSymptomIdx < 0) {
                                                this.navSelectRelatedSymptom(0);
                                            }
                                            else if (currentRelatedSymptomIdx === (this.relatedSymptomList.length - 1)) {
                                                this.navSelectRelatedSymptom(0);
                                            }
                                            else {
                                                this.navSelectRelatedSymptom(currentRelatedSymptomIdx + 1);
                                            }

                                        }
                                    }
                                    break;

                                case AP_PANEL.QUESTIONS_PANEL:
                                    this.navAnswersDown();
                                    break;

                            }
                        }
                        // CTRL + DOWN
                        else if (event.shiftKey === false && event.altKey === false && event.ctrlKey === true) {

                            switch (this.shortcutNav.crtPanel) {
                                case AP_PANEL.RELATED_SYMPTOMS:
                                    if (this.relatedSymptomList.length > 0) {
                                        this.navSelectRelatedSymptom(this.relatedSymptomList.length - 1);
                                    }
                                    break;

                                case AP_PANEL.QUESTIONS_PANEL:
                                    this.navAnswersBottom();
                                    break;
                            }
                        }
                        // SHIFT + DOWN
                        else if (event.shiftKey === true && event.altKey === false && event.ctrlKey === false) {

                            // Small and Up (> 600px)
                            // One column with RELATED_SYMPTOMS and possible NO_OTHER_SYMPTOMS
                            // One columns with QUESTIONS_PANEL
                            if (this.$vuetify.breakpoint.smAndUp) {

                                switch (this.shortcutNav.crtPanel) {
                                    case AP_PANEL.RELATED_SYMPTOMS:
                                        if (this.noOtherSymptomsCheck === true) {
                                            this.navSetShortcutNavCrtPanel(AP_PANEL.NO_OTHER_SYMPTOMS, true);
                                        }
                                        break;

                                    case AP_PANEL.NO_OTHER_SYMPTOMS:
                                        this.navSetShortcutNavCrtPanel(AP_PANEL.RELATED_SYMPTOMS, true);
                                        break;

                                    case AP_PANEL.QUESTIONS_PANEL:
                                        this.navQuestionsDown();
                                        break;
                                }
                            }
                            // Extra small (<600px)
                            // One column with RELATED_SYMPTOMS, possible NO_OTHER_SYMPTOMS and QUESTIONS_PANEL
                            else if (this.$vuetify.breakpoint.xsOnly) {

                                switch (this.shortcutNav.crtPanel) {
                                    case AP_PANEL.RELATED_SYMPTOMS:
                                        if (this.noOtherSymptomsCheck === true) {
                                            this.navSetShortcutNavCrtPanel(AP_PANEL.NO_OTHER_SYMPTOMS, true);
                                        }
                                        break;

                                    case AP_PANEL.NO_OTHER_SYMPTOMS:
                                        this.navQuestionsTop();
                                        break;

                                    case AP_PANEL.QUESTIONS_PANEL:

                                        let crtQuestionIdx = this.navGetCrtQuestionIdx();
                                        if (crtQuestionIdx < 0) {
                                            this.navSelectQuestion(0);
                                        }
                                        else {
                                            if (crtQuestionIdx === (this.questionListPriority.length - 1)) {
                                                this.navSetShortcutNavCrtPanel(AP_PANEL.RELATED_SYMPTOMS, true);
                                            }
                                            else {
                                                this.navSelectQuestion(crtQuestionIdx + 1);
                                            }
                                        }
                                        break;
                                }
                            }
                        }
                        // SHIFT + CTRL + DOWN
                        else if (event.shiftKey === true && event.altKey === false && event.ctrlKey === true) {

                            // Small and Up (> 600px)
                            // One column with RELATED_SYMPTOMS and possible NO_OTHER_SYMPTOMS
                            // One columns with QUESTIONS_PANEL
                            if (this.$vuetify.breakpoint.smAndUp) {

                                switch (this.shortcutNav.crtPanel) {
                                    case AP_PANEL.RELATED_SYMPTOMS:
                                        if (this.noOtherSymptomsCheck === true) {
                                            this.navSetShortcutNavCrtPanel(AP_PANEL.NO_OTHER_SYMPTOMS, true);
                                        }
                                        break;

                                    case AP_PANEL.NO_OTHER_SYMPTOMS:
                                        break;

                                    case AP_PANEL.QUESTIONS_PANEL:
                                        this.navQuestionsBottom();
                                        break;

                                }
                            }
                            // Extra small (<600px)
                            // One column with RELATED_SYMPTOMS, possible NO_OTHER_SYMPTOMS and QUESTIONS_PANEL
                            else if (this.$vuetify.breakpoint.xsOnly) {
                                this.navQuestionsBottom();
                            }
                        }
                        break;

                }
            },

            handleKeyUps(event) {

                this.isKeyDown[event.keyCode] = false;

                if (this.mustShowScoringPopup === true || this.mustShowUrgentPopup === true || this.mustShowInfoPopup === true || this.mustShowVitalParametersForm === true) {
                    return;
                }

                switch (event.keyCode) {

                    // Tab
                    case 9:
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        return false;

                    //Enter
                    case 13:
                        // Ctrl + Enter
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === true) {
                            event.preventDefault();
                            event.stopPropagation();
                            event.stopImmediatePropagation();

                            // Close the patient comment popup on Ctrl + Enter
                            if (this.getShowUserComment === true) {
                                this.savePatientComment();
                                this.navSetIsKeyboardNav(true);
                            }
                        }
                        break;

                    // Shift
                    case 16:
                        if (this.getShowUserComment === false) {
                            event.preventDefault();
                            this.navDisablePanelHighlight();
                            this.navFocusPanelElement();
                        }
                        break;

                    // ALT
                    case 18:
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        return false;

                }
            },

            handleClicks(event) {

                this.shortcutNav.isKeyboardNav = false;
            },

            // On Events

            onChangeAnswer(data) {

                this.navSelectQuestion(0);
            },

            onQuestionClick(data) {

                if (data === null || data.questionCode === null) {
                    return;
                }

                let isDifferentQuestion = (this.shortcutNav.crtQuestion !== data.questionCode);

                this.shortcutNav.crtQuestion = data.questionCode;

                let crtQuestionIdx = this.navGetCrtQuestionIdx();
                if (crtQuestionIdx < 0) {
                    crtQuestionIdx = 0;
                }

                this.navSetShortcutNavCrtPanel(AP_PANEL.QUESTIONS_PANEL, false);

                if (this.questionListPriority.length === 0) {
                    return;
                }

                let question = this.questionListPriority[crtQuestionIdx];

                // It can ce a different code if was executed "crtQuestionIdx = 0;"
                this.shortcutNav.crtQuestion = question.code;

                if (question.answers.length === 0) {
                    return;
                }

                if (isDifferentQuestion === true) {
                    this.shortcutNav.crtAnswer = question.answers[0].code;
                }
            },

            onRelatedSymptomClick(data) {

                if (data.symptomCode === null || data.symptomYes === null) {
                    return;
                }

                this.navSetShortcutNavCrtPanel(AP_PANEL.RELATED_SYMPTOMS, false);

                this.shortcutNav.crtRelatedSymptom = data.symptomCode;
                this.shortcutNav.crtRelatedSymptomYes = data.symptomYes;

                this.navFindCheckboxRelatedSymptom(false);

            },

            onRelatedSymptomsPanelClick() {

                this.navSetShortcutNavCrtPanel(AP_PANEL.RELATED_SYMPTOMS, false);

                if (this.shortcutNav.crtRelatedSymptom === null && this.relatedSymptomList.length > 0) {

                    this.shortcutNav.crtRelatedSymptom = this.relatedSymptomList[0].code;

                    this.navFindCheckboxRelatedSymptom(false);
                }
            },

            onNoOtherSymptomsPanelClick() {
                this.navSetShortcutNavCrtPanel(AP_PANEL.NO_OTHER_SYMPTOMS, false);
            },

            // Panel Highlight Enable/Disable

            navEnablePanelHighlight() {

                this.shortcutNav.isPanelHighlight = true;
                this.shortcutNav.isKeyboardNav = true;

                this.navScrollIntoViewPanelOrSymptoms();
            },

            navDisablePanelHighlight() {

                this.shortcutNav.isPanelHighlight = false;
            },

            navFocusPanelElement() {

                switch (this.shortcutNav.crtPanel) {

                    case AP_PANEL.RELATED_SYMPTOMS:
                        if (this.relatedSymptomList.length > 0) {
                            if (this.shortcutNav.crtRelatedSymptom === null) {
                                this.navSelectRelatedSymptom(0);
                            }
                            else {
                                let relatedSymptomIdx = this.navGetCurrentRelatedSymptomIdx();
                                if (relatedSymptomIdx >= 0) {
                                    this.navFindCheckboxRelatedSymptom(true);
                                }
                                else {
                                    this.navSelectRelatedSymptom(0);
                                }
                            }
                        }
                        break;

                    case AP_PANEL.NO_OTHER_SYMPTOMS:

                        this.navFindCheckboxNoOtherSymptoms(true);
                        break;

                    case AP_PANEL.QUESTIONS_PANEL:

                        if (this.shortcutNav.crtQuestion === null) {
                            this.navSelectQuestion(0);
                        }
                        break;
                }

            },

            navHandleDropdownsAfterClosingPopups(newValue) {

                if (newValue === false) {

                    switch (this.shortcutNav.crtPanel) {

                        case AP_PANEL.RELATED_SYMPTOMS:
                            this.navFindCheckboxRelatedSymptom(true);
                            break;

                        case AP_PANEL.NO_OTHER_SYMPTOMS:
                            this.navFindCheckboxNoOtherSymptoms(true);
                            break;

                        case AP_PANEL.QUESTIONS_PANEL:
                            break;
                    }
                }
            },

            // Change current panel

            navSetShortcutNavCrtPanel(crtPanelNew, isScrollIntoView) {

                let crtPanelOld = this.shortcutNav.crtPanel;
                this.shortcutNav.crtPanel = crtPanelNew;

                if (isScrollIntoView === true) {
                    this.navScrollIntoViewPanelOrSymptoms();
                }

                // We make actions only if the actual panel changed
                if (crtPanelOld !== crtPanelNew) {

                    switch (crtPanelOld) {

                        case AP_PANEL.RELATED_SYMPTOMS:
                            if (this.checkboxRelatedSymptom != null) {
                                this.checkboxRelatedSymptom.$el.blur();
                            }
                            break;

                        case AP_PANEL.NO_OTHER_SYMPTOMS:
                            if (this.checkboxNoOtherSymptoms != null) {
                                this.checkboxNoOtherSymptoms.$el.blur();
                            }
                            break;

                        case AP_PANEL.QUESTIONS_PANEL:
                            break;
                    }
                }
            },

            navSetIsKeyboardNav(isNavigation) {

                if (this.shortcutNav.isKeyboardNav === false && isNavigation === true) {
                    this.navFocusPanelElement();
                }

                this.shortcutNav.isKeyboardNav = isNavigation;
            },
            setIsKeyboardNav(value) {
                this.shortcutNav.isKeyboardNav = value;
            },

            // Scroll Into View

            navScrollIntoViewRelatedSymptom() {

                if (this.shortcutNav.crtRelatedSymptom === null) {
                    return;
                }

                let relatedSymptomPanel = document.querySelector('#RELATED_S_' + this.shortcutNav.crtRelatedSymptom);
                let containerScrollable = document.querySelector('.scrolling-content-symptoms-priority-list');
                containerScrollable.scrollTop = relatedSymptomPanel.offsetTop - 162;
            },

            navScrollIntoViewPanelOrSymptoms() {

                if (this.shortcutNav.crtPanel === AP_PANEL.QUESTIONS_PANEL) {

                    let crtQuestionIdx = this.navGetCrtQuestionIdx();
                    if (crtQuestionIdx < 0) {
                        this.navSelectQuestion(0);
                    }
                    else {
                        this.navScrollIntoViewCrtQuestion();
                    }
                }
                else {
                    let panel = document.querySelector('#' + this.shortcutNav.crtPanel);
                    let containerScrollable = document.querySelector('.scrolling-content-symptoms-priority-list');
                    containerScrollable.scrollTop = panel.offsetTop - 10;
                }
            },

            navScrollIntoViewCrtQuestion() {

                if (this.shortcutNav.crtQuestion === null) {
                    return;
                }

                if (this.$refs["symptomsQuestionsContentListModeRef"] != null
                    && this.$refs["symptomsQuestionsContentListModeRef"].$refs["symptomsPriorityListRef"] != null
                    && this.$refs["symptomsQuestionsContentListModeRef"].$refs["symptomsPriorityListRef"].$refs['vFlexQuestionRef_' + this.shortcutNav.crtQuestion] != null
                    && this.$refs["symptomsQuestionsContentListModeRef"].$refs["symptomsPriorityListRef"].$refs['vFlexQuestionRef_' + this.shortcutNav.crtQuestion][0]) {

                    let containerScrollable = document.querySelector('.scrolling-content-symptoms-priority-list');
                    let questionPanel = this.$refs["symptomsQuestionsContentListModeRef"].$refs["symptomsPriorityListRef"].$refs['vFlexQuestionRef_' + this.shortcutNav.crtQuestion][0];

                    containerScrollable.scrollTop = questionPanel.offsetTop - 35;
                }
            },

            // RELATED SYMPTOMS Panel

            navSelectRelatedSymptom(selectRelatedSymptomIdx) {

                if (this.relatedSymptomList.length === 0) {
                    return;
                }

                let relatedSymptom = this.relatedSymptomList[selectRelatedSymptomIdx];
                this.shortcutNav.crtRelatedSymptom = relatedSymptom.code;

                this.navFindCheckboxRelatedSymptom(true);
            },

            navGetCurrentRelatedSymptomIdx() {

                let currentSymptomIdx = -1;
                if (this.shortcutNav.crtRelatedSymptom != null) {
                    currentSymptomIdx = this.relatedSymptomList.findIndex((symptom, index) => {
                        if (symptom.code === this.shortcutNav.crtRelatedSymptom) {
                            return true;
                        }
                    });
                }
                return currentSymptomIdx;
            },

            navFindCheckboxRelatedSymptom(withFocus) {

                // Reset first the this.checkboxRelatedSymptom to don't keep an old reference to other checkbox
                this.checkboxRelatedSymptom = null;

                if (this.shortcutNav.crtRelatedSymptom === null) {
                    return;
                }

                let identifierSuffix;
                if (this.shortcutNav.crtRelatedSymptomYes === true) {
                    identifierSuffix = '_YES';
                }
                else {
                    identifierSuffix = '_NO';
                }

                if (this.$refs["symptomsQuestionsContentListModeRef"] != null
                    && this.$refs["symptomsQuestionsContentListModeRef"].$refs["relatedSymptomsRef"] != null
                    && this.$refs["symptomsQuestionsContentListModeRef"].$refs["relatedSymptomsRef"].$refs['RELATED_SYMPTOM_' + this.shortcutNav.crtRelatedSymptom + identifierSuffix] != null
                    && this.$refs["symptomsQuestionsContentListModeRef"].$refs["relatedSymptomsRef"].$refs['RELATED_SYMPTOM_' + this.shortcutNav.crtRelatedSymptom + identifierSuffix][0] != null) {

                    this.checkboxRelatedSymptom = this.$refs["symptomsQuestionsContentListModeRef"].$refs["relatedSymptomsRef"].$refs['RELATED_SYMPTOM_' + this.shortcutNav.crtRelatedSymptom + identifierSuffix][0];

                    if (withFocus === true) {
                        this.checkboxRelatedSymptom.$el.focus();
                        this.navScrollIntoViewRelatedSymptom();
                    }
                }
            },

            // NO OTHER SYMPTOMS Panel

            navFindCheckboxNoOtherSymptoms(withFocus) {

                if (this.$refs["symptomsQuestionsContentListModeRef"] != null
                    && this.$refs["symptomsQuestionsContentListModeRef"].$refs["relatedSymptomsRef"] != null
                    && this.$refs["symptomsQuestionsContentListModeRef"].$refs["relatedSymptomsRef"].$refs["noOtherSymptomsRef"] != null) {

                    this.checkboxNoOtherSymptoms = this.$refs["symptomsQuestionsContentListModeRef"].$refs["relatedSymptomsRef"].$refs["noOtherSymptomsRef"];

                    if (withFocus === true) {
                        this.checkboxNoOtherSymptoms.$el.focus();
                    }
                }
            },

            // Questions Navigation

            navQuestionsDown() {

                let crtQuestionIdx = this.navGetCrtQuestionIdx();
                if (crtQuestionIdx < 0) {
                    this.navSelectQuestion(0);
                    return;
                }

                if (crtQuestionIdx === (this.questionListPriority.length - 1)) {
                    this.navSelectQuestion(0);
                }
                else {
                    this.navSelectQuestion(crtQuestionIdx + 1);
                }
            },

            navQuestionsUp() {

                let crtQuestionIdx = this.navGetCrtQuestionIdx();
                if (crtQuestionIdx < 0) {
                    this.navSelectQuestion(0);
                    return;
                }

                if (crtQuestionIdx === 0) {
                    this.navSelectQuestion(this.questionListPriority.length - 1);
                }
                else {
                    this.navSelectQuestion(crtQuestionIdx - 1);
                }
            },

            navQuestionsBottom() {
                this.navSelectQuestion(this.questionListPriority.length - 1);
            },

            navQuestionsTop() {
                this.navSelectQuestion(0);
            },

            navAnswersRightLeft(toRight) {

                if (this.shortcutNav.crtAnswer === null) {
                    this.navSelectQuestion(0);
                    return;
                }

                let crtQuestionIdx = this.navGetCrtQuestionIdx();
                if (crtQuestionIdx < 0) {
                    this.navSelectQuestion(0);
                    return;
                }

                let question = this.questionListPriority[crtQuestionIdx];

                let answerIdx = question.answers.findIndex((currentAnswer) => {
                    return currentAnswer.code === this.shortcutNav.crtAnswer;
                });

                if (answerIdx < 0) {
                    this.navSelectQuestion(crtQuestionIdx);
                    return;
                }

                if (toRight === true) {
                    // RIGHT
                    if (answerIdx === (question.answers.length - 1)) {

                        this.navSelectQuestionAnswer(crtQuestionIdx, 0);
                    }
                    else {
                        this.navSelectQuestionAnswer(crtQuestionIdx, answerIdx + 1);
                    }
                }
                else {
                    // LEFT
                    if (answerIdx === 0) {

                        this.navSelectQuestionAnswer(crtQuestionIdx, question.answers.length - 1);
                    }
                    else {
                        this.navSelectQuestionAnswer(crtQuestionIdx, answerIdx - 1);
                    }
                }
            },

            navAnswersRightEdge() {

                if (this.shortcutNav.crtAnswer === null) {
                    this.navSelectQuestion(0);
                    return;
                }

                let crtQuestionIdx = this.navGetCrtQuestionIdx();
                if (crtQuestionIdx < 0) {
                    this.navSelectQuestion(0);
                    return;
                }

                let question = this.questionListPriority[crtQuestionIdx];

                let answerIdx = question.answers.findIndex((currentAnswer) => {
                    return currentAnswer.code === this.shortcutNav.crtAnswer;
                });

                if (answerIdx < 0) {
                    this.navSelectQuestion(crtQuestionIdx);
                    return;
                }

                let answerTagList = {};

                question.answers.forEach((currentAnswer) => {
                    answerTagList[currentAnswer.code] = this.$refs["symptomsQuestionsContentListModeRef"].$refs["symptomsPriorityListRef"].$refs['divAnswerRef_' + currentAnswer.code][0];
                });

                let crtAnswer = question.answers[answerIdx];

                let crtAnswerPanel = answerTagList[crtAnswer.code];

                let crtAnswerRect = crtAnswerPanel.getBoundingClientRect();

                let crtYMiddle = crtAnswerRect.top + ( crtAnswerRect.height / 2 );

                let farthestRightAnswer = null;
                let foundCurrentAnswer = false;

                question.answers.forEach((currentAnswer) => {

                    if (currentAnswer.code === crtAnswer.code) {
                        foundCurrentAnswer = true;
                        // Was found the current Answer. Do nothing for it.
                        return;
                    }

                    // Evaluate only answers after current Answer
                    if (foundCurrentAnswer === true) {

                        let currentAnswerTag = answerTagList[currentAnswer.code];
                        if (currentAnswerTag != null) {

                            let currentAnswerRect = currentAnswerTag.getBoundingClientRect();

                            let currentAnswerYMiddle = currentAnswerRect.top + ( currentAnswerRect.height / 2 );

                            //Search only for right buttons on the same line
                            if (crtYMiddle === currentAnswerYMiddle) {
                                farthestRightAnswer = currentAnswer;
                            }
                        }
                    }
                });

                if (farthestRightAnswer != null) {
                    this.navSelectQuestionAnswer(crtQuestionIdx, this.navGetAnswerIdx(question, farthestRightAnswer));
                }

            },

            navAnswersLeftEdge() {

                if (this.shortcutNav.crtAnswer === null) {
                    this.navSelectQuestion(0);
                    return;
                }

                let crtQuestionIdx = this.navGetCrtQuestionIdx();
                if (crtQuestionIdx < 0) {
                    this.navSelectQuestion(0);
                    return;
                }

                let question = this.questionListPriority[crtQuestionIdx];

                let answerIdx = question.answers.findIndex((currentAnswer) => {
                    return currentAnswer.code === this.shortcutNav.crtAnswer;
                });

                if (answerIdx < 0) {
                    this.navSelectQuestion(crtQuestionIdx);
                    return;
                }

                let answerTagList = {};

                question.answers.forEach((currentAnswer) => {
                    answerTagList[currentAnswer.code] = this.$refs["symptomsQuestionsContentListModeRef"].$refs["symptomsPriorityListRef"].$refs['divAnswerRef_' + currentAnswer.code][0];
                });

                let crtAnswer = question.answers[answerIdx];

                let crtAnswerPanel = answerTagList[crtAnswer.code];

                let crtAnswerRect = crtAnswerPanel.getBoundingClientRect();

                let crtYMiddle = crtAnswerRect.top + ( crtAnswerRect.height / 2 );

                let farthestLeftAnswer = null;
                let foundCurrentAnswer = false;

                let answerListLength = question.answers.length;
                for (let i = answerListLength - 1; i >= 0; i--) {

                    let currentAnswer = question.answers[i];

                    if (currentAnswer.code === crtAnswer.code) {
                        foundCurrentAnswer = true;
                    }
                    // Evaluate only answers after current Answer
                    else if (foundCurrentAnswer === true) {

                        let currentAnswerTag = answerTagList[currentAnswer.code];
                        if (currentAnswerTag != null) {

                            let currentAnswerRect = currentAnswerTag.getBoundingClientRect();

                            let currentAnswerYMiddle = currentAnswerRect.top + ( currentAnswerRect.height / 2 );

                            //Search only for left buttons on the same line
                            if (crtYMiddle === currentAnswerYMiddle) {
                                farthestLeftAnswer = currentAnswer;
                            }
                        }
                    }
                }

                if (farthestLeftAnswer != null) {
                    this.navSelectQuestionAnswer(crtQuestionIdx, this.navGetAnswerIdx(question, farthestLeftAnswer));
                }

            },

            navAnswersDown() {

                if (this.shortcutNav.crtAnswer === null) {
                    this.navSelectQuestion(0);
                    return;
                }

                let crtQuestionIdx = this.navGetCrtQuestionIdx();
                if (crtQuestionIdx < 0) {
                    this.navSelectQuestion(0);
                    return;
                }

                let question = this.questionListPriority[crtQuestionIdx];

                let answerIdx = question.answers.findIndex((currentAnswer) => {
                    return currentAnswer.code === this.shortcutNav.crtAnswer;
                });

                if (answerIdx < 0) {
                    this.navSelectQuestion(crtQuestionIdx);
                    return;
                }

                let answerTagList = {};

                question.answers.forEach((currentAnswer) => {
                    answerTagList[currentAnswer.code] = this.$refs["symptomsQuestionsContentListModeRef"].$refs["symptomsPriorityListRef"].$refs['divAnswerRef_' + currentAnswer.code][0];
                });

                let crtAnswer = question.answers[answerIdx];

                let crtAnswerPanel = answerTagList[crtAnswer.code];

                let crtAnswerRect = crtAnswerPanel.getBoundingClientRect();

                let crtXMiddle = crtAnswerRect.left + ( crtAnswerRect.width / 2 );
                let crtYMiddle = crtAnswerRect.top + ( crtAnswerRect.height / 2 );

                let nearestBellowAnswerDiff = null;
                let nearestBellowAnswer = null;
                let nextLineY = null;

                let foundCurrentAnswer = false;

                question.answers.forEach((currentAnswer) => {

                    if (currentAnswer.code === crtAnswer.code) {
                        foundCurrentAnswer = true;
                        // Was found the current Answer. Do nothing for it.
                        return;
                    }

                    // Evaluate only answers after current Answer
                    if (foundCurrentAnswer === true) {

                        let currentAnswerTag = answerTagList[currentAnswer.code];
                        if (currentAnswerTag != null) {

                            let currentAnswerRect = currentAnswerTag.getBoundingClientRect();

                            let currentAnswerXLeft = currentAnswerRect.left;
                            let currentAnswerXRight = currentAnswerRect.right;

                            let currentAnswerYMiddle = currentAnswerRect.top + ( currentAnswerRect.height / 2 );

                            //Search only for bellow buttons

                            if (crtYMiddle < currentAnswerYMiddle) {

                                if (nextLineY === null) {
                                    // Store the Y of the next line
                                    nextLineY = currentAnswerYMiddle;
                                }
                                else if (nextLineY < currentAnswerYMiddle) {
                                    // Consider only next line. Return if we start to check 2 lines bellow
                                    return;
                                }

                                let currentDistanceLeft = this.getDistance(crtXMiddle, crtYMiddle, currentAnswerXLeft, currentAnswerYMiddle);
                                let currentDistanceRight = this.getDistance(crtXMiddle, crtYMiddle, currentAnswerXRight, currentAnswerYMiddle);

                                // Choose the near one
                                let currentDistance;
                                if (currentDistanceLeft < currentDistanceRight) {
                                    currentDistance = currentDistanceLeft;
                                }
                                else {
                                    currentDistance = currentDistanceRight;
                                }

                                if (nearestBellowAnswerDiff === null) {
                                    nearestBellowAnswerDiff = currentDistance;
                                    nearestBellowAnswer = currentAnswer;
                                }
                                else if (currentDistance < nearestBellowAnswerDiff) {
                                    nearestBellowAnswerDiff = currentDistance
                                    nearestBellowAnswer = currentAnswer;
                                }
                            }
                        }
                    }
                });

                if (nearestBellowAnswer != null) {
                    this.navSelectQuestionAnswer(crtQuestionIdx, this.navGetAnswerIdx(question, nearestBellowAnswer));
                }
                else {
                    // Was not found bellow. Navigate to the first line, vertically

                    let nearestAnswerDiff = null;
                    let nearestAnswer = null;

                    let firstLineY = null;

                    question.answers.forEach((currentAnswer) => {

                        if (currentAnswer.code !== crtAnswer.code) {

                            let currentAnswerTag = answerTagList[currentAnswer.code];
                            if (currentAnswerTag != null) {

                                let currentAnswerRect = currentAnswerTag.getBoundingClientRect();

                                let currentAnswerXLeft = currentAnswerRect.left;
                                let currentAnswerXRight = currentAnswerRect.right;

                                let currentAnswerYMiddle = currentAnswerRect.top + ( currentAnswerRect.height / 2 );

                                //Search only for bellow buttons

                                if (crtYMiddle > currentAnswerYMiddle) {

                                    if (firstLineY === null) {
                                        // Store the Y of the first line
                                        firstLineY = currentAnswerYMiddle;
                                    }
                                    else if (firstLineY < currentAnswerYMiddle) {
                                        // Consider only first line. Return if we start to check lines bellow
                                        return;
                                    }

                                    let currentDistanceLeft = this.getDistance(crtXMiddle, crtYMiddle, currentAnswerXLeft, currentAnswerYMiddle);
                                    let currentDistanceRight = this.getDistance(crtXMiddle, crtYMiddle, currentAnswerXRight, currentAnswerYMiddle);

                                    // Choose the near one
                                    let currentDistance;
                                    if (currentDistanceLeft < currentDistanceRight) {
                                        currentDistance = currentDistanceLeft;
                                    }
                                    else {
                                        currentDistance = currentDistanceRight;
                                    }

                                    if (nearestAnswerDiff === null) {
                                        nearestAnswerDiff = currentDistance;
                                        nearestAnswer = currentAnswer;
                                    }
                                    else if (currentDistance < nearestAnswerDiff) {
                                        nearestAnswerDiff = currentDistance
                                        nearestAnswer = currentAnswer;
                                    }
                                }
                            }
                        }
                    });

                    if (nearestAnswer != null) {
                        this.navSelectQuestionAnswer(crtQuestionIdx, this.navGetAnswerIdx(question, nearestAnswer));
                    }
                    else {
                        // Do nothing
                    }
                }

            },

            navAnswersUp() {

                if (this.shortcutNav.crtAnswer === null) {
                    this.navSelectQuestion(0);
                    return;
                }

                let crtQuestionIdx = this.navGetCrtQuestionIdx();
                if (crtQuestionIdx < 0) {
                    this.navSelectQuestion(0);
                    return;
                }

                let question = this.questionListPriority[crtQuestionIdx];

                if (question.answeredByVitalParam !== null) {
                    return;
                }

                let answerIdx = question.answers.findIndex((currentAnswer) => {
                    return currentAnswer.code === this.shortcutNav.crtAnswer;
                });

                if (answerIdx < 0) {
                    this.navSelectQuestion(crtQuestionIdx);
                    return;
                }

                let answerTagList = {};

                question.answers.forEach((currentAnswer) => {
                    answerTagList[currentAnswer.code] = this.$refs["symptomsQuestionsContentListModeRef"].$refs["symptomsPriorityListRef"].$refs['divAnswerRef_' + currentAnswer.code][0];
                });

                let crtAnswer = question.answers[answerIdx];

                let crtAnswerPanel = answerTagList[crtAnswer.code];

                let crtAnswerRect = crtAnswerPanel.getBoundingClientRect();

                let crtXMiddle = crtAnswerRect.left + ( crtAnswerRect.width / 2 );
                let crtYMiddle = crtAnswerRect.top + ( crtAnswerRect.height / 2 );

                let nearestAnswerDiff = null;
                let nearestAnswer = null;
                let previousLineY = null;

                let answerListLength = question.answers.length;
                for (let i = answerListLength - 1; i >= 0; i--) {

                    let currentAnswer = question.answers[i];

                    // Evaluate only answers after current Answer
                    if (currentAnswer.code !== crtAnswer.code) {

                        let currentAnswerTag = answerTagList[currentAnswer.code];
                        if (currentAnswerTag != null) {

                            let currentAnswerRect = currentAnswerTag.getBoundingClientRect();

                            let currentAnswerXLeft = currentAnswerRect.left;
                            let currentAnswerXRight = currentAnswerRect.right;

                            let currentAnswerYMiddle = currentAnswerRect.top + ( currentAnswerRect.height / 2 );

                            //Search only for bellow buttons

                            if (crtYMiddle > currentAnswerYMiddle) {

                                if (previousLineY === null) {
                                    // Store the Y of the previous line
                                    previousLineY = currentAnswerYMiddle;
                                }
                                else if (previousLineY > currentAnswerYMiddle) {
                                    // Consider only previous line. Return if we start to check 2 lines above
                                    continue;
                                }

                                let currentDistanceLeft = this.getDistance(crtXMiddle, crtYMiddle, currentAnswerXLeft, currentAnswerYMiddle);
                                let currentDistanceRight = this.getDistance(crtXMiddle, crtYMiddle, currentAnswerXRight, currentAnswerYMiddle);

                                // Choose the near one
                                let currentDistance;
                                if (currentDistanceLeft < currentDistanceRight) {
                                    currentDistance = currentDistanceLeft;
                                }
                                else {
                                    currentDistance = currentDistanceRight;
                                }

                                if (nearestAnswerDiff === null) {
                                    nearestAnswerDiff = currentDistance;
                                    nearestAnswer = currentAnswer;
                                }
                                else if (currentDistance < nearestAnswerDiff) {
                                    nearestAnswerDiff = currentDistance
                                    nearestAnswer = currentAnswer;
                                }
                            }
                        }
                    }
                }

                if (nearestAnswer != null) {
                    this.navSelectQuestionAnswer(crtQuestionIdx, this.navGetAnswerIdx(question, nearestAnswer));
                }
                else {
                    // Was not found above. Navigate to the last line, vertically

                    let nearestAnswerDiff = null;
                    let nearestAnswer = null;

                    let lastLineY = null;

                    let answerListLength = question.answers.length;
                    for (let i = answerListLength - 1; i >= 0; i--) {

                        let currentAnswer = question.answers[i];

                        if (currentAnswer.code !== crtAnswer.code) {

                            let currentAnswerTag = answerTagList[currentAnswer.code];
                            if (currentAnswerTag != null) {

                                let currentAnswerRect = currentAnswerTag.getBoundingClientRect();

                                let currentAnswerXLeft = currentAnswerRect.left;
                                let currentAnswerXRight = currentAnswerRect.right;

                                let currentAnswerYMiddle = currentAnswerRect.top + ( currentAnswerRect.height / 2 );

                                if (crtYMiddle < currentAnswerYMiddle) {

                                    if (lastLineY === null) {
                                        // Store the Y of the last line
                                        lastLineY = currentAnswerYMiddle;
                                    }
                                    else if (lastLineY > currentAnswerYMiddle) {
                                        // Consider only last line
                                        continue;
                                    }

                                    let currentDistanceLeft = this.getDistance(crtXMiddle, crtYMiddle, currentAnswerXLeft, currentAnswerYMiddle);
                                    let currentDistanceRight = this.getDistance(crtXMiddle, crtYMiddle, currentAnswerXRight, currentAnswerYMiddle);

                                    // Choose the near one
                                    let currentDistance;
                                    if (currentDistanceLeft < currentDistanceRight) {
                                        currentDistance = currentDistanceLeft;
                                    }
                                    else {
                                        currentDistance = currentDistanceRight;
                                    }

                                    if (nearestAnswerDiff === null) {
                                        nearestAnswerDiff = currentDistance;
                                        nearestAnswer = currentAnswer;
                                    }
                                    else if (currentDistance < nearestAnswerDiff) {
                                        nearestAnswerDiff = currentDistance
                                        nearestAnswer = currentAnswer;
                                    }
                                }
                            }
                        }
                    }

                    if (nearestAnswer != null) {
                        this.navSelectQuestionAnswer(crtQuestionIdx, this.navGetAnswerIdx(question, nearestAnswer));
                    }
                    else {
                        // Do nothing
                    }
                }

            },

            navAnswersTop() {

                if (this.shortcutNav.crtAnswer === null) {
                    this.navSelectQuestion(0);
                    return;
                }

                let crtQuestionIdx = this.navGetCrtQuestionIdx();
                if (crtQuestionIdx < 0) {
                    this.navSelectQuestion(0);
                    return;
                }

                let question = this.questionListPriority[crtQuestionIdx];

                let answerIdx = question.answers.findIndex((currentAnswer) => {
                    return currentAnswer.code === this.shortcutNav.crtAnswer;
                });

                if (answerIdx < 0) {
                    this.navSelectQuestion(crtQuestionIdx);
                    return;
                }

                let answerTagList = {};

                question.answers.forEach((currentAnswer) => {
                    answerTagList[currentAnswer.code] = this.$refs["symptomsQuestionsContentListModeRef"].$refs["symptomsPriorityListRef"].$refs['divAnswerRef_' + currentAnswer.code][0];
                });

                let crtAnswer = question.answers[answerIdx];

                let crtAnswerPanel = answerTagList[crtAnswer.code];

                let crtAnswerRect = crtAnswerPanel.getBoundingClientRect();

                let crtXMiddle = crtAnswerRect.left + ( crtAnswerRect.width / 2 );
                let crtYMiddle = crtAnswerRect.top + ( crtAnswerRect.height / 2 );

                // Navigate to the first line, vertically

                let nearestAnswerDiff = null;
                let nearestAnswer = null;

                let firstLineY = null;

                question.answers.forEach((currentAnswer) => {

                    if (currentAnswer.code !== crtAnswer.code) {

                        let currentAnswerTag = answerTagList[currentAnswer.code];
                        if (currentAnswerTag != null) {

                            let currentAnswerRect = currentAnswerTag.getBoundingClientRect();

                            let currentAnswerXLeft = currentAnswerRect.left;
                            let currentAnswerXRight = currentAnswerRect.right;

                            let currentAnswerYMiddle = currentAnswerRect.top + ( currentAnswerRect.height / 2 );

                            //Search only for bellow buttons

                            if (crtYMiddle > currentAnswerYMiddle) {

                                if (firstLineY === null) {
                                    // Store the Y of the first line
                                    firstLineY = currentAnswerYMiddle;
                                }
                                else if (firstLineY < currentAnswerYMiddle) {
                                    // Consider only first line. Return if we start to check lines bellow
                                    return;
                                }

                                let currentDistanceLeft = this.getDistance(crtXMiddle, crtYMiddle, currentAnswerXLeft, currentAnswerYMiddle);
                                let currentDistanceRight = this.getDistance(crtXMiddle, crtYMiddle, currentAnswerXRight, currentAnswerYMiddle);

                                // Choose the near one
                                let currentDistance;
                                if (currentDistanceLeft < currentDistanceRight) {
                                    currentDistance = currentDistanceLeft;
                                }
                                else {
                                    currentDistance = currentDistanceRight;
                                }

                                if (nearestAnswerDiff === null) {
                                    nearestAnswerDiff = currentDistance;
                                    nearestAnswer = currentAnswer;
                                }
                                else if (currentDistance < nearestAnswerDiff) {
                                    nearestAnswerDiff = currentDistance
                                    nearestAnswer = currentAnswer;
                                }
                            }
                        }
                    }
                });

                if (nearestAnswer != null) {
                    this.navSelectQuestionAnswer(crtQuestionIdx, this.navGetAnswerIdx(question, nearestAnswer));
                }
                else {
                    // Do nothing
                }

            },

            navAnswersBottom() {

                if (this.shortcutNav.crtAnswer === null) {
                    this.navSelectQuestion(0);
                    return;
                }

                let crtQuestionIdx = this.navGetCrtQuestionIdx();
                if (crtQuestionIdx < 0) {
                    this.navSelectQuestion(0);
                    return;
                }

                let question = this.questionListPriority[crtQuestionIdx];

                let answerIdx = question.answers.findIndex((currentAnswer) => {
                    return currentAnswer.code === this.shortcutNav.crtAnswer;
                });

                if (answerIdx < 0) {
                    this.navSelectQuestion(crtQuestionIdx);
                    return;
                }

                let answerTagList = {};

                question.answers.forEach((currentAnswer) => {
                    answerTagList[currentAnswer.code] = this.$refs["symptomsQuestionsContentListModeRef"].$refs["symptomsPriorityListRef"].$refs['divAnswerRef_' + currentAnswer.code][0];
                });

                let crtAnswer = question.answers[answerIdx];

                let crtAnswerPanel = answerTagList[crtAnswer.code];

                let crtAnswerRect = crtAnswerPanel.getBoundingClientRect();

                let crtXMiddle = crtAnswerRect.left + ( crtAnswerRect.width / 2 );
                let crtYMiddle = crtAnswerRect.top + ( crtAnswerRect.height / 2 );

                // Navigate to the last line, vertically

                let nearestAnswerDiff = null;
                let nearestAnswer = null;

                let lastLineY = null;

                let answerListLength = question.answers.length;
                for (let i = answerListLength - 1; i >= 0; i--) {

                    let currentAnswer = question.answers[i];

                    if (currentAnswer.code !== crtAnswer.code) {

                        let currentAnswerTag = answerTagList[currentAnswer.code];
                        if (currentAnswerTag != null) {

                            let currentAnswerRect = currentAnswerTag.getBoundingClientRect();

                            let currentAnswerXLeft = currentAnswerRect.left;
                            let currentAnswerXRight = currentAnswerRect.right;

                            let currentAnswerYMiddle = currentAnswerRect.top + ( currentAnswerRect.height / 2 );

                            if (crtYMiddle < currentAnswerYMiddle) {

                                if (lastLineY === null) {
                                    // Store the Y of the last line
                                    lastLineY = currentAnswerYMiddle;
                                }
                                else if (lastLineY > currentAnswerYMiddle) {
                                    // Consider only last line
                                    continue;
                                }

                                let currentDistanceLeft = this.getDistance(crtXMiddle, crtYMiddle, currentAnswerXLeft, currentAnswerYMiddle);
                                let currentDistanceRight = this.getDistance(crtXMiddle, crtYMiddle, currentAnswerXRight, currentAnswerYMiddle);

                                // Choose the near one
                                let currentDistance;
                                if (currentDistanceLeft < currentDistanceRight) {
                                    currentDistance = currentDistanceLeft;
                                }
                                else {
                                    currentDistance = currentDistanceRight;
                                }

                                if (nearestAnswerDiff === null) {
                                    nearestAnswerDiff = currentDistance;
                                    nearestAnswer = currentAnswer;
                                }
                                else if (currentDistance < nearestAnswerDiff) {
                                    nearestAnswerDiff = currentDistance
                                    nearestAnswer = currentAnswer;
                                }
                            }
                        }
                    }
                }

                if (nearestAnswer != null) {
                    this.navSelectQuestionAnswer(crtQuestionIdx, this.navGetAnswerIdx(question, nearestAnswer));
                }
                else {
                    // Do nothing
                }

            },

            // QUESTIONS Panels

            navSelectQuestion(selectQuestionIdx) {

                this.navSelectQuestionAnswer(selectQuestionIdx, 0);
            },

            navSelectQuestionAnswer(selectQuestionIdx, selectAnswerIdx) {

                this.navSetShortcutNavCrtPanel(AP_PANEL.QUESTIONS_PANEL, false);

                if (this.questionListPriority.length === 0) {
                    return;
                }

                let question = this.questionListPriority[selectQuestionIdx];
                this.shortcutNav.crtQuestion = question.code;

                this.navScrollIntoViewCrtQuestion();

                if (question.answers.length === 0) {
                    return;
                }

                this.shortcutNav.crtAnswer = question.answers[selectAnswerIdx].code;
            },

            navGetCrtQuestionIdx() {

                let crtQuestionIdx = -1;
                if (this.shortcutNav.crtQuestion != null) {
                    crtQuestionIdx = this.questionListPriority.findIndex((currentQuestion, currentIndex) => {
                        if (currentQuestion.code === this.shortcutNav.crtQuestion) {
                            return true;
                        }
                    });
                }
                return crtQuestionIdx;
            },

            navGetAnswerIdx(questionParam, answerParam) {

                let answerIdx = -1;
                answerIdx = questionParam.answers.findIndex((currentAnswer) => {
                    if (currentAnswer.code === answerParam.code) {
                        return true;
                    }
                });
                return answerIdx;
            },

            getDistance(crtAnswerXMiddle, crtAnswerYMiddle, relatedAnswerX, relatedAnswerYMiddle) {

                let xDiff = Math.abs(relatedAnswerX - crtAnswerXMiddle);
                let yDiff = Math.abs(crtAnswerYMiddle - relatedAnswerYMiddle);

                return Math.sqrt((xDiff * xDiff) + (yDiff * yDiff));
            },

            navGotoFirstPage() {
                if(!this.getMustShowAssessmentList) {
                    this.$router.push('/assessment-start');
                } else {
                    this.$router.push('/assessment-start-list');
                }
            }

            /*******************************
             ***   KEYBOARD NAVIGATION   ***
             ***        END CODE         ***
             *******************************/

        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

    .container-symptoms-questions.grid-list-xl {

        .page-content{
            margin-top: 40px;

        }

        .related-symptoms {

            .related {
                padding: 0 20px 30px;
            }
        }

        .selected-symptoms {
            padding: 12px 0;


            .shared-questions {
                padding-left: 20px;
            }
        }
    }

    .btn-menu {
        max-width: 50px;
        margin-right: 50px;

        .settings {
            width: 15%;
        }
    }

    .btn-logout {
        max-width: 50px;
        margin-right: 50px;
    }

    .toolbar--fixed.header {
        background-color: $color-on-primary;
        padding: 0 20px;
        overflow: hidden;
        box-shadow: none;
        border-bottom: 3px solid $color-gray-lightest;
    }

    .user {
        width: 8%;
        margin-right: 10px;
    }

    .top-bar-no-margin{
        height: 50px;
    }

    .symptoms-questions-content {
        margin-top: 22px !important;
    }
    .alerts-top {
        display: inline-flex;
    }


    .patient-info-priority-list {
        position: fixed;
        right: 175px !important;
    }

    .comment-block-priority-list {
        position: relative;
        bottom: 10px;
        //position: fixed;
        //right: 0;
    }
    .comment-block-priority-list.assessment-sealed textarea {
        color: $color-element-outline;
    }
</style>




// WEBPACK FOOTER //
// src/professional/components/symptoms-questions/symptoms-priority-list/AssessmentSymptomsPriorityListPage.vue